import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../store/Reducers/OrderErrorsSlice';
import { OrderErrorsDatagrid } from '../../components/DataGrid/OrderErrors/OrderErrorsDatagrid';

export const OrderErrorsPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, [dispatch]);

  return <OrderErrorsDatagrid />;
};
